import 'braid-design-system/reset';
import { HirerAuthProvider } from '@seek/hirer-auth-react';
import { HirerApolloProvider } from '@seek/hirer-graphql-react';
import { UivBanner } from '@seek/uiv-banner';
import { VocabProvider } from '@vocab/react';
import { BraidProvider, ToastProvider } from 'braid-design-system';
import seekJobs from 'braid-design-system/themes/seekJobs';
import type { PropsWithChildren } from 'react';

import { ConfigProvider } from 'src/hooks/providers/ConfigProvider';
import { QueryParamProvider } from 'src/hooks/providers/QueryParamProvider';
import type { ClientContext, ConfigOptions } from 'src/types';

import {
  getGraphUri,
  logErrorDev,
  logError,
  logGraphQLErrorDev,
  logGraphQLError,
} from '../utils/gqlLogging';

import { AppTitle } from './components/AppTitle/AppTitle';
import { JobsListPage } from './layouts/JobsListPage/JobsListPage';

const HirerProvidersWrapper = ({
  conf,
  children,
}: PropsWithChildren<{ conf: ConfigOptions }>) => (
  <HirerAuthProvider
    authenticationLevel={
      conf.environment === 'development' && !conf.useAuth ? 'None' : 'Hirer'
    }
  >
    <HirerApolloProvider
      appName="hirer-jobs-list"
      site={conf.site}
      uri={getGraphUri(conf)}
      logError={conf.environment === 'development' ? logErrorDev : logError}
      logGraphQLError={
        conf.environment === 'development'
          ? logGraphQLErrorDev
          : logGraphQLError
      }
      environment={conf.environment}
    >
      {children}
    </HirerApolloProvider>
  </HirerAuthProvider>
);

export default ({ config }: ClientContext) => (
  <VocabProvider language={config.locale}>
    <AppTitle />
    <BraidProvider theme={seekJobs}>
      <UivBanner
        applicationName="hirer-jobs-list-ui"
        branch={config.branch}
        version={config.version}
      />
      <ToastProvider>
        <ConfigProvider value={config}>
          <HirerProvidersWrapper conf={config}>
            <QueryParamProvider>
              <JobsListPage />
            </QueryParamProvider>
          </HirerProvidersWrapper>
        </ConfigProvider>
      </ToastProvider>
    </BraidProvider>
  </VocabProvider>
);
